import React, {  } from "react";
import { useSelector } from "react-redux";
import {
  resourceSelector,
} from "../../store/config/configurationSlice";
import { isEmpty } from "lodash";
const Footer = () => {
  const data = useSelector(resourceSelector);

  return (
    !isEmpty(data) && (
      <div id="myAeroFooterDvNew" dangerouslySetInnerHTML={{ __html: data?.footerMarkup }}></div>
    )
  );
};
export default Footer;
